import { render } from "./SkeletonHeroBanner.vue?vue&type=template&id=3b265d12"
import script from "./SkeletonHeroBanner.vue?vue&type=script&lang=js"
export * from "./SkeletonHeroBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__